import type { I18n } from '@lingui/core';
import { t } from '@lingui/macro';

export const correct = (i18n: I18n) =>
  t(i18n)({
    message: 'Correct!',
    id: 'common.correct',
  });

export const incorrect = (i18n: I18n) =>
  t(i18n)({
    message: 'Not quite!',
    id: 'common.incorrect',
  });

export const youngerGeneration = (i18n: I18n) =>
  t(i18n)({
    message: '15-24 year-olds',
    id: 'common.younger-generation',
  });

export const olderGeneration = (i18n: I18n) =>
  t(i18n)({
    message: '40+ year-olds',
    id: 'common.older-generation',
  });

export const ageGroup1 = (i18n: I18n) =>
  t(i18n)({
    message: '15-24 year-olds',
    id: 'common.age-group-1',
  });

export const ageGroup2 = (i18n: I18n) =>
  t(i18n)({
    message: '25-39 year-olds',
    id: 'common.age-group-2',
  });

export const ageGroup3 = (i18n: I18n) =>
  t(i18n)({
    message: '40-64 year-olds',
    id: 'common.age-group-3',
  });

export const ageGroup4 = (i18n: I18n) =>
  t(i18n)({
    message: '65+ year-olds',
    id: 'common.age-group-4',
  });

export const better = (i18n: I18n) =>
  t(i18n)({
    message: 'Better',
    id: 'common.better',
  });

export const worse = (i18n: I18n) =>
  t(i18n)({
    message: 'Worse',
    id: 'common.worse',
  });

export const highIncomeCountries = (i18n: I18n) =>
  t(i18n)({
    message: 'High-income countries',
    id: 'common.high-income-countries',
  });

export const upperMidIncomeCountries = (i18n: I18n) =>
  t(i18n)({
    message: 'Upper-Middle Income Countries',
    id: 'common.upper-mid-income-countries',
  });

export const lowerMiddleIncomeCountries = (i18n: I18n) =>
  t(i18n)({
    message: 'Lower-middle Income Countries',
    id: 'common.lower-mid-income-countries',
  });

export const midIncomeCountries = (i18n: I18n) =>
  t(i18n)({
    message: 'Middle-income countries',
    id: 'common.mid-income-countries',
  });

export const lowIncomeCountries = (i18n: I18n) =>
  t(i18n)({
    message: 'Low-income countries',
    id: 'common.low-income-countries',
  });

export const lowLowerMiddleIncomeCountries = (i18n: I18n) =>
  t(i18n)({
    message: 'Low/Lower-Middle Income Countries',
    id: 'common.low-lower-middle-income-countries',
  });

export const socialMedia = (i18n: I18n) =>
  t(i18n)({
    message: 'Social media',
    id: 'common.social-media',
  });

export const onlineNewsSources = (i18n: I18n) =>
  t(i18n)({
    message: 'Online news sources',
    id: 'common.online-news-sources',
  });
